import { render, staticRenderFns } from "./examine-approve.vue?vue&type=template&id=0ca53d7c&scoped=true"
import script from "./examine-approve.vue?vue&type=script&lang=js"
export * from "./examine-approve.vue?vue&type=script&lang=js"
import style0 from "./examine-approve.vue?vue&type=style&index=0&id=0ca53d7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca53d7c",
  null
  
)

export default component.exports